import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  pageWrapper: {
    paddingTop: '32px'
  },
  emptyPlaceholderImg: {
    marginRight: '40px'
  },
  emptyPlaceholder: {
    padding: '60px',
    marginTop: '32px',
    display: 'flex',
    alignItems: 'center'
  },
  topSectionWrapper: {
    paddingTop: '32px',
    position: 'relative',
    backgroundColor: palette.shades[200],
    [breakpointsFunc.breakpoints.down('sm')]: {
      paddingTop: '24px'
    }
  },
  saverDesktop: {
    [breakpointsFunc.breakpoints.down('sm')]: {
      display: 'none'
    },
    '@media print': {
      marginBottom: '18px'
    }
  },
  saverMobile: {
    display: 'none',
    [breakpointsFunc.breakpoints.down('sm')]: {
      display: 'block',
      marginTop: '32px'
    }
  }
}));
export default useStyles;